import styles from './dots-pagination.module.scss';

type DotsPaginationProps = {
    data: {id: string; children: React.ReactNode}[];
    activeIndex: number;
};

export function DotsPagination({data, activeIndex}: DotsPaginationProps) {
    return (
        <div className={styles.pagination}>
            {data.map((_, i) => (
                <div
                    key={i}
                    className={`${styles.paginationItem} ${
                        activeIndex === i ? styles.paginationItemActive : ''
                    }`}
                />
            ))}
        </div>
    );
}
